import React from "react";
import styles from "./PauseOverlay.module.scss";

interface PauseOverlayProps {
  show: boolean;
  onResume: () => void;
  message?: string;
  isPausedByTab?: boolean;
}

export const PauseOverlay: React.FC<PauseOverlayProps> = ({
  show,
  onResume,
  message,
  isPausedByTab = false,
}) => {
  if (!show) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <h2 className={styles.title}>Game Paused</h2>
        {isPausedByTab && <p className={styles.subtitle}>Tab switched away</p>}
        {message && <p className={styles.message}>{message}</p>}
        <button
          className={styles.resumeButton}
          onClick={onResume}
          aria-label="Resume game"
        >
          Resume
        </button>
      </div>
    </div>
  );
};
